import {getToken} from '@/utils/auth';
/**
 * 时间转换
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        time = parseInt(time)
      } else {
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}


/**
 * 金额逗号分隔展示
 * @param {*} s 总金额
 * @param {*} n 保留小数位数
 */
export function fmoney (s, n) {
  n = n >= 0 && n <= 10 ? n : 2;
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + ""; 
  let l = s.split(".")[0].split("").reverse(), r = s.split(".")[1];  
  let t = "";  
  for (let i = 0; i < l.length; i++) {  
      t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");  
  }  
  return t.split("").reverse().join("") + `${n === 0 ? '' : "." + r}`;
}


/**
 * 获取时间计算值
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  let d;
  if (typeof time === 'object') {
    d = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        time = parseInt(time)
      } else {
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    d = new Date(time)
  }
  const now = Date.now()
  const diff = (now - d) / 1000
  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}
/**
 * 下载文件导出
 */
export function download (downloadUrl, fileName) {
  let xhr = new XMLHttpRequest();
  xhr.responseType = "arraybuffer";
  xhr.open("get", downloadUrl, true);
  xhr.setRequestHeader('X-Token', getToken());
  xhr.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      let blob = new Blob([xhr.response], {
        type: "application/vnd.ms-excel",
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
  };
 xhr.send();
}

/**
 * 时间戳转换成时间长度
 * @params: time需要转换的时间
 */
export function timeConvertUtil (time, isEnglish) {
  if (!time) return '';
  let result = parseInt(time);
　let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
　let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
　let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
  if (parseInt(h) > 0) return isEnglish ? `${h}h${m}min${s}s` : `${h}时${m}分${s}秒`;
  if (parseInt(m) > 0) return isEnglish ? `${m}min${s}s` : `${m}分${s}秒`;
  if (parseInt(s) > 0) return isEnglish ? `${s}s` : `${s}秒`;
}

/**
 * 时间转换成时间梯度
 * @params:time需要转换的时间
 */
export function getTimelineTime (time) {
  const fixNum = function (a) {
    return a < 10 ? `0${a}` : a;
  };
  if (time) {
    const before = new Date(time);
    const now = Date.now();
    const diff = (now - before.getTime()) / 1000;
    if (diff < 3600) return Math.ceil(diff / 60) + '分钟前';
    else return `${fixNum(before.getHours())}:${fixNum(before.getMinutes())}:${fixNum(before.getSeconds())}`;
  } else {
    return '';
  }
}

export function getTimelineDate (date) {
  if (date) {
    const now = new Date();
    const pNow = new Date(`${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}`);
    const pDate = new Date(date);
    const isDay = (now - pDate) / 1000 / 60 / 60 / 24;
    if (parseInt(isDay) === 0) return `今天 ${date}`;
    else if (parseInt(isDay) <= 6) return `周${['天', '一', '二', '三', '四', '五', '六'][pDate.getDay()]} ${date}`;
    else return date;
  }
  return date;
}